import { useEffect, useState } from 'react';
import axios from 'axios';

// Probes the client-requests API once to learn whether the feature flag is on
// (backend returns 503 while CLIENT_REQUESTS_ENABLED is off). The feature is on
// by default, so we render optimistically (buttons appear WITH the page, not a
// beat later) and only hide if the probe comes back 503 — the rare kill-switch.
let cached = null;

export default function useClientRequestsEnabled() {
    const [enabled, setEnabled] = useState(cached !== null ? cached : true);

    useEffect(() => {
        if (cached !== null) {
            setEnabled(cached);
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                await axios.get('/api/client-requests/requests/my', { params: { status: 'pending' } });
                cached = true;
            } catch (err) {
                cached = err.response?.status !== 503;
            }
            if (!cancelled) setEnabled(cached);
        })();
        return () => { cancelled = true; };
    }, []);

    return enabled;
}
